<template>
    <div>
        <el-form class="category-attr" :model="formData" :rules="rules" ref="form" v-loading="loading">
            <!-- <div class="smart-match-tip" v-if="showMatchTip">
                <div>
                    <div><i class="el-icon-warning-outline icon"></i>系统已自动预测类目属性，如信息正确可点击智能填充</div>
                    <div class="match-infos">
                        <span v-for="(matchProp, indx) in matchPropNames" :key="matchProp.propName + indx" style="margin-right: 10px;"> {{ matchProp.propName}}: {{ matchProp.propValue }} </span>
                    </div>
                </div>
                <div>
                    <el-button type="primary" class="fill-btn" @click="oneClickFill">一键填充</el-button>
                    <el-button type="link" class="delete-btn" @click="showMatchTip=false">x</el-button>
                </div>
            </div> -->
            <div v-for="(item, idx) in attrs" :key="item.id"
                :class="['attr-item', {'three-item': [4, 9].includes(item.propertyValueType)}, {'hide-item': (item.showCondition && !item.visible)}]"
            >
            <el-form-item :ref="item.idName" v-if="!(item.showCondition && !item.visible)" :label="item.name" label-position="top" :prop="item.idName" :key="item.id" class="el-form-item-top">
                <!-- 选择框 0 values -->
                <el-select
                    width="180px"
                    v-if="(item.values && item.values.length && !isBrand(item) && item.propertyValueType !== 9)"
                    :value="formData[item.idName]"
                    @change="onSelectChange($event, item)"
                    :data-id="item.id"
                    :key="idx"
                    placeholder="请选择"
                    :filterable="item.chooseMaxNum === 1"
                    clearable
                    :multiple="item.chooseMaxNum !== 1"
                    :multiple-limit="item.chooseMaxNum"
                    :popper-append-to-body="false"
                    class="select-wrp"
                    value-key="vid"
                >
                    <el-option
                        v-for="(op, opidx) in (item.options || item.values)"
                        :key="item.id + '-' + opidx + op.vid"
                        :label="op.value"
                        :value="op">
                    </el-option>
                </el-select>
                <!-- 材质成分 9 -->
                <MaterialComposition
                    v-else-if="item.propertyValueType === 9"
                    v-model="formData[item.idName]"
                    :item="item"
                    :options="item.values"
                />
                <!-- <el-select 
                    width="180px" 
                    v-else-if="(isBrand(item))"
                    :value="formData[item.idName]" 
                    @change="onSelectChange($event, item)" 
                    @visible-change="brandVisibleChange(item)"
                    :data-id="item.id" 
                    :key="idx" 
                    placeholder="请选择"
                    filterable
                    :filter-method="(v) => remoteSearch(v, item)"
                    clearable
                    :popper-append-to-body="false"
                    class="select-wrp"
                    value-key="vid"
                >
                    <el-option
                        v-for="(op, opidx) in (item.options || item.values)"
                        :key="item.id + '-' + opidx + op.vid"
                        :label="op.value"
                        :value="op">
                    </el-option>
                </el-select> -->
                <!-- 输入框 0 -->
                <Input 
                    v-else-if="((item.propertyValueType === 1) || (item.propertyValueType === 0 && !item.values))" 
                    :item="item" 
                    v-model="formData[item.idName]"
                    :valueUnit="formatValueUnit(item.idName)"
                    @changeUnits="changeUnits"
                />
                <!-- 日期选择 5 7 -->
                <el-date-picker
                    v-else-if="item.propertyValueType === 5 || item.propertyValueType === 7"
                    width="180px"
                    v-model="formData[item.idName]"
                    :type="item.propertyValueType === 5 ? 'date' : 'month'"
                    placeholder="选择日期"
                    :picker-options="{disabledDate: (time) => disabledDate(item, time)}"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
                <!-- 日期范围选择 6 8 -->
                <DateRange
                    v-else-if="item.propertyValueType === 6 || item.propertyValueType === 8"
                    :item="item"
                    :disabledDate="disabledDate"
                    v-model="formData[item.idName]"
                />
                <!-- 多输入框 11 12 13 -->
                <MultiInput 
                    v-else-if="item.propertyValueType === 2 || item.propertyValueType === 3 || item.propertyValueType === 4"
                    v-model="formData[item.idName]"
                    :item="item"
                    @changeUnits="changeUnits"
                />
            </el-form-item>
            </div>
            <template>
                <span class="update-brand">找不到商品属性？
                    <el-link :underline="false" @click="chooseShop">
                        {{radio ? '切换店铺' : '选择店铺精确查找'}}
                    </el-link>
                </span>
            </template>
        </el-form>
        <el-dialog
            title="选择该店铺下的品牌/属性"
            :visible.sync="dialogVisible"
        >
            <div>
                <el-radio-group
                    v-model="radio"
                >
                    <el-radio
                        v-for="shop in shopList"
                        :label="shop.id"
                        :key="shop.id"
                    >
                        {{ shop.shortTitle || shop.title }}
                    </el-radio>
                </el-radio-group>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
// import { getCategoryAndPropertiesMatch } from '@/servers/prod/center'
import {
  getPddCategoryProperties,
  searchPropertyValue
} from '@/servers/prod/center/pdd.js';
import Input from './Input.vue';
import DateRange from './DateRange.vue';
import MultiInput from './MultiInput.vue';
import MaterialComposition from './MaterialComposition.vue';
import {isChild, getAttrByParentId, getConditionItems} from '../utils';
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
// import attrs from '../attrs';

export default {
  components: {
      Input,
      DateRange,
      MultiInput,
      MaterialComposition
  },
  model: {
      prop: 'value',
      event: 'change'
  },
  props: {
    categoryIds: {
      type: Array,
      default() {
        return []
      }
    },
    value: {
        type: Array,
        default() {
            return []
        }
    },
    initAttrData: {
        type: Array,
        default() {
            return []
        }
    },
    baseItemId: [Number, String],
    pddConfig: {
        type: Object,
        default() {
            return {}
        }
    },
    goodsSn: {
        type: String,
        default: ''
    },
  },
  data() {
      return {
        shopList: [],
        rules: {},
        attrs: [],
        formData: {},
        conditionsAttrs: [], // 受控类目属性
        parentIds: [], // 控制子集的父级refid
        loading: false, // 类目属性loading
        selectVidItems: {},
        units: {},
        id: '',
        dialogVisible: false,
        radio: '',
        fetchAttrsShopIndexs: [],
        // matchPropValues: [],
        // showMatchTip: false,
        // matchPropNames: [],
      }
  },
  computed: {
      ...mapGetters(['shops_updateIndex', 'get_AllShops_BySource']),
      categoryId() {
          if (!this.categoryIds.length) return '';
          return this.categoryIds[this.categoryIds.length - 1];
      }
  },
  watch: {
    categoryId: {
        handler(id) {
            this.formData = {}
            this.rules = {}
            this.id = id
            this.fetchAttrsShopIndexs = []
            if (this.id) {
                this.fetchAttrs()
                // this.getCategoryPropertiesMatchData();
            }
        },
        immediate: true
    },
    formData: {
        deep: true,
        handler(v) {
            let res = [];
            for (let key in v) {
                if (v[key]) {
                    let value = v[key];
                    if (value) {
                        let vval = '';
                        let vid = '';
                        const refPid = key.replace('name', '');
                        if (Array.isArray(value)) {
                            // 材质成分特殊处理：如果数组元素包含 tableInfoDto，说明是材质成分数据
                            if (value.length > 0 && value[0]?.tableInfoDto) {
                                // 材质成分数据，直接添加
                                value.forEach(v => {
                                    res.push({...v, refPid: refPid});
                                });
                            } else {
                                // 普通多选数据
                                value.forEach(v => {
                                    res.push({refPid: refPid, vvalue: v.value, vid: Number(v.vid), name: v.name})
                                })
                            }
                        } else {
                            // vval = value.value;
                            // 尝试修复日期选择组件无效问题
                            vval = typeof value === 'object' ? value.value : value
                            vid = value.vid;
                            let unit = this.units[key] || null
                            if (vval) {
                                let val = {refPid: refPid, vvalue: vval, vid: Number(vid), name: value.name};
                                if (unit) {
                                    val.valueUnit = unit
                                }   
                                res.push(val)
                            }
                        }
                    }
                }
            }
            this.$emit('change', res);
        }
    },
    units: {
        deep: true,
        handler(v) {
            for (let key in v) {
                const refPid = key.replace('name', '');
                const item = this.value.find(it => it.refPid === refPid);
                if (item) {
                    item.valueUnit = v[key];
                }
            }
            this.$emit('change', this.value);
        }
    },
    initAttrData: {
        handler(val) {
            this.updateFormData();
        },
        deep: true
    },
  },
  methods: {
    ...mapActions(["updateCatePropShopIndex"]),
    validatorAttr(prop) {
        return (rule, value, callback) => {
            // 材质成分校验：检查数据是否包含 tableInfoDto（材质成分的特征）
            if (prop.propertyValueType === 9 && Array.isArray(value) && value.length > 0) {
                // 检查是否所有行都填写
                const hasData = value.every(item => item.vvalue && item.tableInfoDto?.tableValueList?.[0]?.value);
                if (!hasData) {
                    // 如果没有填写任何数据，根据 required 规则判断
                    callback(new Error('请完善材质成分'));
                    return;
                }
                // 校验百分比之和是否为 100%
                const total = value.reduce((sum, item) => {
                    const percentage = parseFloat(item.tableInfoDto?.tableValueList?.[0]?.value);
                    return sum + (isNaN(percentage) ? 0 : percentage * 100);
                }, 0);
                // 保留两位小数后比较，避免浮点数精度问题
                if (total !== 10000) {
                    callback(new Error('材质成分百分比之和必须等于 100%'));
                } else {
                    callback();
                }
                return;
            }

            // 临时修复日期类型组件填入后校验未通过问题
            if (!value || ((typeof value === 'object' && !Array.isArray(value)) && !value.value)) {
                callback(new Error(''));
            } else {
                callback();
            }
        }
    },
    confirm() {
        if (!this.radio) {
            this.$message.warning('请选择店铺');
            return;
        }
        this.fetchAttrs(true);
    },
    async fetchAttrs(isUpdate, shopId) {
        this.dialogVisible = false;
        isUpdate && this.updateCatePropShopIndex("pdd")
        this.loading = true;
        let res = await getPddCategoryProperties({
            leafCategoryId: this.id,
        }, this.radio || shopId);
        const updateIndex = this.shops_updateIndex('pdd') 
        if(!res){
            this.loading = false;
            if(!this.radio) {
                if(!this.fetchAttrsShopIndexs.includes(updateIndex)) {
                    this.fetchAttrsShopIndexs.push(updateIndex)
                    this.fetchAttrs(true);
                }
            }
            return;
        }
        let {goodsPropertiesRule, twoPiecesDiscountRule, goodsServiceRule } = res;
        this.$emit('updateDiscount',twoPiecesDiscountRule);
        // 商品服务
        this.$emit('updateGoodsServiceRule', goodsServiceRule);
        let _data = []
        let hasBrand = false;
        const canNotItems = (goodsPropertiesRule?.properties || []).filter(prop => {
            if (prop.isSale) return true
            // 品牌项单独提出来了。这里去掉,
            if (!this.isBrand(prop) && !prop.isSale) {
                _data.push(prop);
            } else {
                hasBrand = true;
            }
            return false
        });
        this.$emit('updateSpec', canNotItems, goodsPropertiesRule?.inputMaxSpecNum);
        this.categoryProperties = _data;
        this.updateFormData();
        this.loading = false;
    },
    updateFormData() {
        const data = _.cloneDeep(this.categoryProperties);
        if (data) {
            this.$refs.form.clearValidate()
            let rules = {};
            let shouldUpdateChild = [];
            this.attrs = data.map((item) => {
                // 受控项处理
                if (item.showCondition) {
                    const ids = item.showCondition.map(it => it.parentRefPid);
                    this.parentIds = this.parentIds.concat(ids);
                    // 子级，受其他项控制
                    item.visible = false;
                    this.conditionsAttrs.push(item);
                } 

                item.idName = item.refPid + 'name';
                // 校验rules
                if (item.required) {
                    const text  = this.isSelect(item) ? '请选择' : '请输入';
                    rules[item.idName] = [
                        {required: true, message: text + item.name, trigger: 'change'},
                        {validator: this.validatorAttr(item), trigger: 'change'},
                    ]
                }
                // 通过initAttrData设置输入框的值
                let val = '';
                const valueItems = this.initAttrData.filter(it => it.refPid == item.refPid);
                if (valueItems.length) {
                    const attrValueItem = valueItems[0];
                    // 材质成分特殊处理 (propertyValueType === 9)
                    if (item.propertyValueType === 9) {
                        // 材质成分数据，直接使用 valueItems 数组
                        val = valueItems.map(v => ({
                            ...v,
                            material: v.vvalue,
                            percentage: v.tableInfoDto?.tableValueList?.[0]?.value ? parseFloat(v.tableInfoDto.tableValueList[0].value) : null
                        }));
                    } else if (item.values && item.values.length) {
                        if (item.chooseMaxNum !== 1) {
                            val = [];
                            valueItems.forEach(va => {
                                if (va.vvalue.indexOf(',') !== -1) {
                                    let vArr = va.vvalue.split(',');
                                    let vidArr = va.vid.split(',');
                                    vArr.forEach((iv, iidx) => {
                                        const isMatch = item.values.some(vs => vs.vid === Number(vidArr[iidx]))
                                        isMatch && val.push({...va, value: iv, vid: Number(vidArr[iidx])});
                                    })
                                } else {
                                    const isMatch = item.values.some(vs => vs.vid === Number(va.vid))
                                    isMatch && val.push({...va, vid: Number(va.vid),  value: va.vvalue, name: item.name});
                                }
                            })
                        } else {
                            const isMatch = item.values.some(vs => vs.vid === attrValueItem.vid)
                            val = isMatch ? {
                                refPid: attrValueItem.refPid,
                                value: attrValueItem.vvalue,
                                vid: attrValueItem.vid,
                                name: item.name
                            } : null
                        }
                    } else {
                        val = attrValueItem.vvalue

                        // 组合字段需要特殊处理
                        if ([2, 3, 4].includes(item.propertyValueType)) {
                            const specEnum = {
                                0: 'one',
                                1: 'two',
                                2: 'three',
                                3: 'four'
                            }
                            const newVal = {};
                            (val || '').split(',').forEach((item, index) => {
                                newVal[specEnum[index]] = item;
                            })
                            newVal.value = val;
                            val = newVal
                        }
                    }

                }

                // 设置默认值
                if (!val) {
                    // 数字类型输入框处理
                    if (item.propertyValueType === 1) {
                        if (item.minValue) {
                            val = Number(item.minValue);
                        }
                    }
                    if(item.name === '商品货号' && this.pddConfig.isCommodityNumber) {
                        val = this.goodsSn || ''
                    }
                } else {
                    // 如果有值并且有控制其他输入框，isParent:true
                    let childIdx = getAttrByParentId(data, item.refPid);
                    if (childIdx.length) {
                        shouldUpdateChild.push({...item, val: val})
                    }
                }
                if (this.isBrand(item)) {
                    this.shouldAddToOptions(item, val);
                }
                this.$set(this.formData, item.idName, val);
                return item;
            });
            // 如果父级有值，则子级应该显示
            shouldUpdateChild.forEach(item => {
                this.onSelectChange(item.val, item, true);
            })
            this.rules = rules;
        }
    },
    isSelect(item) {
        return item.values;
    },
    formatValueUnit(idName) {
        const matchItem = this.initAttrData.find(item => {
            return `${item.refPid}` === idName.replace(/name/g, '');
        })
        if (matchItem) {
            return matchItem.valueUnit;
        }
        return '';
        
    },
    disabledDate(item, time) {
        time = time.getTime();
        if (item.valueType === 5 || item.valueType === 4) {
            let min = item.minValue;
            let max = item.maxValue;
            if (min) min = new Date(min);
            if (max) max = new Date(max);
            if (min && max) {
                return !(time > min.getTime() && time < max.getTime())
            } else if (min) {
                return !(time > min.getTime());
            } else if (max) {
                return !(time < max.getTime());
            }
        }
        return false;
    },
    onSelectChange(val, item) {
        if (Array.isArray(val)) {
            val = val.map(v => ({...v, refPid: item.refPid, name: item.name}))
        } else {
            val = {...val, refPid: item.refPid, name: item.name}
        }
        this.$set(this.formData, item.idName, val);
        const refPid = item.refPid;
        if (this.parentIds.includes(refPid)) {
            const attrs = [...this.attrs];
            let parentAttr = attrs.find(i => i.refPid === refPid);
            attrs.forEach((attr, aIdx) => {
                if (isChild(item, attr) && item.values && !Array.isArray(val)) { // 如果为item的子级
                    const conItems = getConditionItems(this.conditionsAttrs, item, val); // 在所有子级中找到符合条件的子级
                    const idx = conItems.findIndex(it => it.refPid === attr.refPid);
                    
                    if (idx !== -1 && parentAttr && parentAttr.visible !== false) { // 当前attr需要显示的子级
                        // conItems[idx].values
                        attrs[aIdx].options = conItems[idx].options;
                        attrs[aIdx].visible = true;

                        // 如果当前下拉框选择的值没有在options下拉列表中，则清空
                        const curVal = this.formData[attr.idName];
                        if(Array.isArray(curVal) && curVal.length) {
                            const filterVals = curVal.filter(valItem => conItems[idx].options?.findIndex(op => op.value === valItem.value))
                            this.$set(this.formData, attr.idName, filterVals);
                        } else if (curVal) {
                            const valIdx = conItems[idx].options?.findIndex(op => op.value === curVal.value);
                            if (valIdx === -1) {
                                this.$set(this.formData, attr.idName, null);
                            }
                        }
                    } else {
                        attr.visible = false;
                        this.$set(this.formData, attr.idName, null);
                        // 如果有下级，则也应该隐藏（第二子级）
                        // if (this.parentIds.includes(attr.refPid)) { 
                        //     const idxs = getAttrByParentId(this.attrs, attr.refPid);
                        //     idxs.forEach(delIdx => {
                        //         attrs[delIdx].visible = false;
                        //         this.$set(this.formData, attrs[delIdx].idName, null);
                        //     })
                        // }
                    }
                }
            })
            this.attrs = attrs;
        }
    },
    shouldAddToOptions(item, val) {
        val = val || {};
        const idx = item.values.findIndex(v => v.vid === val.vid);
        if (idx === -1 && val.value) {
            item.values.unshift({
                extendInfo: null,
                group: null,
                parentVids: null,
                specId: null,
                value: val.value,
                vid: val.vid
            })
        }
    },
    isBrand(attr) {
        // 是否是品牌
        return attr.refPid === 310 || attr.name === '品牌';
    },
    // brandVisibleChange(item) {
    //     item.options = null;
    //     this.$forceUpdate();
    // },
    // async remoteSearch(val, item) {
    //     if (!val) {
    //         item.options = null;
    //         this.$forceUpdate();
    //         return;
    //     }
    //     let filterOptions = (item.values || []).filter(v => v.value.indexOf(val) !== -1);
    //     item.options = filterOptions;
    //     this.$forceUpdate();
    //     const data = await searchPropertyValue({
    //         catId: this.categoryId,
    //         pageNum: 1,
    //         pageSize: 50,
    //         refPid: item.refPid,
    //         value: val
    //     });
    //     if (data && data.goodsTemplatePropValSearchResponse) {
    //         let options = data.goodsTemplatePropValSearchResponse.list || [];
    //         item.options = options;
    //     }
    //     this.$forceUpdate();
    // },
    changeUnits(unit) {
        this.units = {...this.units, ...unit}
    },
    validate() {
        return new Promise((resolve) => {
            this.$refs.form.validate(valid => {
                resolve(valid);
            })
        })
    },

    chooseShop() {
        this.dialogVisible = true;
    },
    // async getCategoryPropertiesMatchData() {
    //     if(!this.categoryId || !this.baseItemId) return;
    //     const data = await getCategoryAndPropertiesMatch({
    //         baseItemId: this.baseItemId,
    //         categoryId: this.categoryId,
    //         platformType: 'pdd',
    //     })
    //     this.matchPropValues = data?.matchPropValues ? JSON.parse(data.matchPropValues) : []
    //     this.matchPropNames = data?.matchPropNames ? JSON.parse(data.matchPropNames) : []
    //     this.showMatchTip = !!this.matchPropValues.length;
    // },
    // oneClickFill() {
    //     this.updateFormData(this.matchPropValues );
    // }
  },
  mounted() {
    this.shopList = this.get_AllShops_BySource('pdd')
  }
}
</script>

<style lang="scss" scoped>
.category-attr {
    position: relative;
    padding-bottom: 20px;
    .smart-match-tip {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background-color: #fffbe6;
        border: 1px solid #ffe58f;
        border-radius: 2px;
        padding: 10px;
        font-size: 14px;
        width: 100%;
        color: #6c6d6f;
        .icon {
            color: #faad14;
            font-size: 24px;
            margin-right: 5px;
        }
        .match-infos {
            font-size: 12px;
            margin-left: 30px;
        }
        .fill-btn {
            margin-right: 30px;
        }
        .delete-btn {
            position: absolute;
            top: 10px;
            right: 20px;
            color: #979494;
        }
    }
    ::v-deep .el-select .el-input {
        width: 100% !important;
    }
    .el-select-dropdown{
        min-width: 180px;
    }
    .pdd-color-picker {
        ::v-deep .el-color-picker__trigger {
            width: 100px;
        }
    }
    .hide-item {
        display: none;
    }
    .select-wrp {
        ::v-deep .el-select-dropdown {
            min-width: 180px;
        }
    }
    .el-form-item-top {
        display: flex;
        flex-direction: column;
        ::v-deep .el-form-item__label{
            text-align: left;
        }
    }
    .update-brand {
        position: absolute;
        left: 20px;
        bottom: 0px;
        font-size: 12px;
    }
}
</style>